export default {
  listTitleTable: {
    TICKER: 'TICKER',
    TYPE: 'TYPE',
    _15MINUTES: '15 MINUTES',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
  },
  MOVING_AVERAGE: 'Moving Average',
  INDICATORS: 'Indicators',
  SUMMARY: 'Summary',

  BULLISH: 'Bullish',
  BEARISH: 'Bearish',
  NEUTRAL: 'Neutral',
  STRONG_BULLISH: 'Strong Bullish',
  STRONG_BEARISH: 'Strong Bearish',
};
